export default __webpack_public_path__ + "static/renovation-tile-6c5b9cc974436bdd9bc9fb81f1e2966b.webp";